import React, { useState } from "react";
import { Metric } from "./types";
import "./tabs.scss";

interface DetailedMetricViewProps {
  metric: Metric;
}

const DetailedMetricView: React.FC<DetailedMetricViewProps> = ({ metric }) => {
  const [showConversation, setShowConversation] = useState(false);

  const getRatingColor = (rating: string) => {
    switch (rating) {
      case "Excellent":
        return "green";
      case "Good":
        return "yellow";
      case "Needs Improvement":
        return "red";
      default:
        return "gray";
    }
  };

  return (
    <div className="detailed-metric-view">
      <div className="metric-header">
        <div className="metric-title-section">
          <div className={`metric-dot ${metric.color}`} />
          <h3 className="metric-title">{metric.name}</h3>
        </div>
        <div className={`metric-score-display ${metric.color}`}>
          {metric.score}/{metric.maxScore}
        </div>
      </div>

      <div className="rating-badge-container">
        <span className={`rating-badge ${getRatingColor(metric.rating)}`}>
          {metric.rating}
        </span>
      </div>

      {metric.description && (
        <div className="metric-description">{metric.description}</div>
      )}

      {metric.suggestion && (
        <div className="suggestion-section">
          <div className="suggestion-icon">💡</div>
          <div>
            <p className="suggestion-label">Suggestion</p>
            <p className="suggestion-text">{metric.suggestion}</p>
          </div>
        </div>
      )}

      {metric.example && (
        <div className="example-section">
          <p className="example-label">Example</p>
          <div className="example-box">{metric.example}</div>
        </div>
      )}

      {metric.conversation_part && metric.conversation_part.length > 0 && (
        <div className="conversation-section">
          <button
            type="button"
            className="conversation-toggle"
            onClick={() => setShowConversation(!showConversation)}
          >
            <span>💬</span>
            <span>View Conversation</span>
            <span>{showConversation ? "▲" : "▼"}</span>
          </button>

          {showConversation && (
            <div className="conversation-details">
              <h4>Conversation Highlights</h4>
              {metric.conversation_part.map((part: any, index: number) => {
                // Create a unique key from the conversation content
                const uniqueKey = `${part.ai_part?.substring(0, 20) || ""}-${
                  part.user_part?.substring(0, 20) || ""
                }-${index}`;
                return (
                  <div key={uniqueKey} className="conversation-pair">
                    <div className="conversation-bubble interviewer">
                      <p className="bubble-label">Interviewer</p>
                      <p className="bubble-text">{part.ai_part}</p>
                    </div>
                    <div className="conversation-bubble candidate">
                      <p className="bubble-label">Candidate</p>
                      <p className="bubble-text">{part.user_part}</p>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default DetailedMetricView;
